<template>
    <div :class="cssClass" v-show="visible">
        <cogi-label :required="required" :label="label"></cogi-label>
        <input type="email" :class="{ cogirequired: required, 'cogi-error': hasError }" v-model="model" placeholder="utilisateur@yahoo.com" @blur="blur" />
    </div>
</template>
<script setup lang="ts">
    import { ref, watch } from 'vue'
    import CogiLabel from './CogiLabel.vue'

    interface IPropsTelephone {
        required?: boolean
        valideNow?: boolean
        label: string
        cssClass?: string
        visible?: boolean
    }

    const props = withDefaults(defineProps<IPropsTelephone>(), {
        required: false,
        valideNow: false,
        label: '',
        cssClass: '',
        visible: true,
    })
    const model = defineModel<string>()

    const hasError = ref(false)

    const emit = defineEmits<{
        validated: [boolean]
    }>()

    function blur() {
        hasError.value = false
    }
    function validate() {
        hasError.value = false

        if (!props.visible) {
            emitValidated(false)
            return
        }

        var emailRegex =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (props.required && !model.value) {
            hasError.value = true
        } else if (!props.required && !model.value) {
            hasError.value = false
        } else {
            if (!emailRegex.test(String(model.value).toLowerCase())) {
                hasError.value = true
            }
        }
        emitValidated(hasError.value)
    }
    function emitValidated(hasError: boolean) {
        emit('validated', hasError)
    }

    watch(
        () => props.valideNow,
        newValue => {
            if (newValue) validate()
        },
    )
</script>
